import { useCallback } from "react";

export function useSetProperty(property: string) {
	const setPropertyCallback = useCallback(
		(node: HTMLDivElement) => {
			if (node !== null) {
				document.documentElement.style.setProperty(property, `${node.offsetHeight}px`);
			}

			return () => {
				document.documentElement.style.removeProperty(property);
			};
		},
		[property],
	);

	return setPropertyCallback;
}
